// import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';

export const selectTermsAndConditions = (state:RootState) => state[Reducers.Terms].termsAndConditions;
export const selectLoading = (state:RootState) => state[Reducers.Terms].loading;